import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  GET_NOTIFICATIONS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/notifications `).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_RESOURCES: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard `).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_QUOTAS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/quotas`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_DISK_STATS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/disk-stats`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PROGRESS_PIE_STATS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/dashboard/scraping-progress-pie-stats`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_KWS_PROGRESS_PIE_STATS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/today-progress-pie-stats`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PROGRESS_CHART: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/dashboard/scraping-progress-chart`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // {'duration_in_months': int (from 1 to 12)}
  GET_DAILY_PROGRESS_CHART: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/dashboard/daily-scraping-stats`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  KEYWORDS_COUNT: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/dashboard/keywords-count`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/dashboard/actions.js